import { CommonMessage } from '@frontend/lang';
import { useAccountRepository } from '@frontend/repository';
import { SpotClient } from '@frontend/spot/api';
import { SpotBadge } from '@frontend/spot/badge';
import { Spot } from '@frontend/spot/types';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface Props {
    filter: string;
}
export const SpotSearch = (props: Props) => {
    const {
        store: { currentAccount }
    } = useAccountRepository();
    const [results, changeResults] = useState<Spot[]>([]);

    useEffect(() => {
        if (props.filter !== '')
            SpotClient.fetchSpots({ account_id: currentAccount, search: props.filter }).then((result) => {
                changeResults(result.results);
            });
    }, [props.filter, currentAccount]);

    if (results.length === 0) return null;
    return (
        <div className='mb-3 p-1'>
            <span className='border-border-default flex flex-row items-center justify-between border-b-1 pb-1'>
                <div className='ml-1 font-bold'>{CommonMessage.OBJECTS.SPOT.DISTRI_SPOTS}</div>
                <Link
                    className='mx-1 text-sm font-medium underline'
                    to='/admin/spots'>
                    {CommonMessage.BUTTONS.SHOW_ALL}
                </Link>
            </span>
            <div className='flex flex-col'>
                {results.map((result) => (
                    <SpotBadge id={result.id} />
                ))}
            </div>
        </div>
    );
};
